import { makeStyles, Theme } from '@material-ui/core';

type Props = {
  statusColour: string;
};

const useStyles = makeStyles((theme: Theme) => ({
  card: (props: Props) => ({
    padding: `${theme.spacing(1)} ${theme.spacing(2)} ${theme.spacing(1)} ${theme.spacing(2)}`,
    borderLeft: `${theme.spacing(1)} solid ${props.statusColour}`,
  }),
  grid: {
    display: 'grid',
    height: '100%',
    width: '100%',
    alignItems: 'center',
  },
  status: {
    flexGrow: 1,
  },
  message: {
    flexGrow: 1,
  },
}));

export default useStyles;
